import type { RequestInterceptor } from '@moon-v2/moon-share';

/**
 * Le SDK MoonShared retombe sur `inLocation` (pays courant, cf. `MoonSharedConfig.inLocation`)
 * dès que le contexte d'appel ne fournit pas de valeur unique — cas des sélections
 * multi-emplacements qui utilisent `inLocation[]`. Le backend privilégie ce `inLocation` pays
 * et ignore le tableau : on le retire dès que `inLocation[]` est présent pour que le filtre
 * multi-emplacements explicite ne soit jamais écrasé par le scope pays implicite.
 */
export const stripCountryInLocationWhenArrayPresent: RequestInterceptor = (config) => {
  const params = config.params as Record<string, unknown> | undefined;
  if (params && 'inLocation[]' in params) {
    delete params['inLocation'];
  }
  return config;
};
